var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"media",attrs:{"muted":"","loop":"","playsinline":"","preload":"metadata","poster":_vm.poster || null,"aria-hidden":"true","tabindex":"-1"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }